import React, { useEffect } from 'react';
import posthog from 'posthog-js';
import Header from './Header';
import Footer from './Footer';
import {
  Hero,
  InterfaceShowcase,
  Features,
  FAQSection,
  Pricing,
  LogoScroll,
} from './components';
import './App.css';
import { initiateCheckout } from './utils/checkout';
import { ADOBE_EXCHANGE_URL } from './constants/urls';

const Home: React.FC = () => {
  const handleInstallClick = () => {
    posthog.capture('install_clicked', { source: 'hero' });
    window.open(ADOBE_EXCHANGE_URL, '_blank', 'noopener,noreferrer');
  };

  const handlePurchase = () => {
    posthog.capture('purchase_clicked', { plan: 'pro' });
    initiateCheckout(
      process.env.REACT_APP_COLOR_CACHE_PRODUCT_ID || '',
      process.env.REACT_APP_COLOR_CACHE_SUBSCRIPTION_PRICE_ID || ''
    );
  };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <Header showNav={true} />
      <Hero onGetStartedClick={handleInstallClick} />
      <LogoScroll />
      <Features />
      <InterfaceShowcase />
      <FAQSection />
      <Pricing onPurchase={handlePurchase} />
      <Footer />
    </div>
  );
};

export default Home;
